import { createFileRoute } from "@tanstack/react-router";
import { SetPasswordForm } from "@/components/auth/set-password-form";

interface ResetSearchParams {
	token: string;
	tenant: string;
}

export const Route = createFileRoute("/reset-hasla")({
	validateSearch: (search: Record<string, unknown>): ResetSearchParams => ({
		token: (search.token as string) || "",
		tenant: (search.tenant as string) || "",
	}),
	component: ResetPasswordPage,
});

function ResetPasswordPage() {
	const { token, tenant } = Route.useSearch();
	return (
		<SetPasswordForm
			token={token}
			tenant={tenant}
			title="Ustaw nowe haslo"
			subtitle="Wpisz nowe haslo do swojego konta."
			submitLabel="Ustaw nowe haslo"
			loadingLabel="Zapisywanie..."
			successTitle="Haslo zmienione"
			successMessage="Twoje haslo zostalo pomyslnie zmienione. Mozesz sie teraz zalogowac."
			errorFallback="Nie udalo sie zmienic hasla"
			invalidLinkMessage="Nieprawidlowy lub brakujacy link do resetu hasla."
		/>
	);
}
